// ReportWizardIntervalType ile kontrol et
export enum ReportTimeIntervalType {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  QUARTER = 'quarter',
}
